import TagsWrapper from './TagsWrapper';
export default TagsWrapper;
